module.exports = __webpack_public_path__ + "static/media/example1.8cf8963b.jpg";